import { useQuery } from "@apollo/client";
import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import Card from "shared/components/Card";
import Container from "shared/components/Container";
import Error from "shared/components/Error";
import List from "shared/components/List";
import Loading from "shared/components/Loading";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";
import { ASSET_TYPES, PRODUCT_TYPES } from "utils/constants";
import Address from "./Address";
import BackLink from "shared/components/BackLink";

function Detail() {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.XO.ACCOUNT);
  const LIST = t("LIST", { returnObjects: true });
  const { data, loading, error } = useQuery(graphql.queries.ASSETS, {
    variables: {
      where: {
        type: ASSET_TYPES.XOB_USD.type,
        collateral: {
          escrow: { product: { type: PRODUCT_TYPES.XOB_LIQUIDITY.value } },
        },
      },
    },
  });

  if (loading) return <Loading />;
  if (error) return <Error />;

  const {
    assets: { data: assets },
  } = data;

  return (
    <Container>
      <BackLink />
      <Row gutter={[16, 16]} justify="center" className="pt-32">
        <Col xs={24} sm={20} md={18} lg={16} xl={16}>
          <Address />
          <div className="pt-32" />
          <Card title={LIST.BODY.TRANSACTIONS.TITLE}>
            <List
              type="grouped"
              data={assets}
              render={([date, items]) => (
                <div key={date} className="transaction__group">
                  <div className="transaction__list--date">
                    <span>{date}</span>
                  </div>
                  {items.map((asset) => (
                    <Card
                      key={asset.id}
                      type="custom"
                      subType="transaction"
                      asset={asset}
                    />
                  ))}
                </div>
              )}
            />
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Detail;
